import { ICTTLAnimateBehavior, ICTTLAnimateColorBehavior, ICTTLSetBehavior, IEGTimeNodeChoice } from '@tencent/slide-sdk-model';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import type { ComponentAnimWrapper } from '../../../canvas-render/elements/component-anim-wrapper';
import { IConverterToStyle, IFromStyle } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';

export type IBehavior = ICTTLAnimateColorBehavior | ICTTLSetBehavior | ICTTLAnimateBehavior;
export interface IAnimKeyframeHandler<T extends IBehavior, M extends IElementBaseModel>{
    parse(behavior: T, duration: number, elementModel: M): IConverterToStyle | undefined;
}

export interface IAnimKeyframeHandlerContext<T extends IBehavior,  M extends IElementBaseModel> {
    setHandler(handler: IAnimKeyframeHandler<T, M>): void;
    executeHandler(
        behavior: T, duration: number, elementModel: M): IConverterToStyle | undefined;
}

export interface IAnimFromStyleConverter {
    convertAnimFromStyle(propNameList: string[], animTarget: ComponentAnimWrapper): IFromStyle | undefined;
}

export interface IAnimToStyleConverter {
    convertAnimToStyle<T extends IElementBaseModel>(params: IParams<T>): IConverterToStyle | undefined;
}

export interface IParams<T> {
    unitTimeNode: IEGTimeNodeChoice;
    // 单位ms
    duration: number;
    elementModel: T;
}


export enum AttrName {
    FILL_COLOR = 'fillcolor',
    FONT_COLOR = 'style.color',
    LINE_COLOR = 'stroke.color',
    FILL_TYPE = 'fill.type',
    FILL_ON = 'fill.on',
    FONT_SIZE = 'style.fontSize',
    FONT_WEIGHT = 'style.fontWeight',
}

export enum ColorType {
    SC_RGB = 'scrgbClr',
    SRGB = 'srgbClr',
    HSL = 'hslClr',
    SCHEME = 'schemeClr',
    SYSTEM = 'sysClr',
}
